import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 5h6a3.5 3.5 0 0 1 0 7h-6l0 -7","key":"svg-0"}],["path",{"d":"M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7","key":"svg-1"}]]

/**
 * IconBold
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm9sZCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA1aDZhMy41IDMuNSAwIDAgMSAwIDdoLTZsMCAtNyIgLz4KICA8cGF0aCBkPSJNMTMgMTJoMWEzLjUgMy41IDAgMCAxIDAgN2gtN3YtNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/bold
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBold = createReactComponent('outline', 'bold', 'Bold', __iconNode);

export default IconBold;